
<template>
  <div class="grid">
    <div class="col-12">
      <Breadcrumb :home="home" :model="items" />
    </div>

    <div class="col-12">
      <DataView :value="Modules" :layout="Layout" v-if="Loading">
        <template #header>
          <div class="flex justify-content-end">
            <div class="border-bottom-1 surface-border">
              <span class="text-xl font-medium text-900">Course Contents</span>
            </div>
            <DataViewLayoutOptions v-model="Layout" />
          </div>
        </template>
        <template #list>
          <div class="col-12">
            <div class="flex flex-column xl:flex-row xl:align-items-start p-4 gap-4">
              <Skeleton class="w-9 sm:w-16rem xl:w-10rem shadow-2 h-6rem block xl:block mx-auto border-round" />
              <div class="flex flex-column sm:flex-row justify-content-between align-items-center xl:align-items-start flex-1 gap-4">
                <div class="flex flex-column align-items-center sm:align-items-start gap-3">
                  <Skeleton class="w-8rem border-round h-2rem" />
                  <Skeleton class="w-6rem border-round h-1rem" />
                  <div class="flex align-items-center gap-3">
                    <Skeleton class="w-6rem border-round h-1rem" />
                    <Skeleton class="w-3rem border-round h-1rem" />
                  </div>
                </div>
                <div class="flex sm:flex-column align-items-center sm:align-items-end gap-3 sm:gap-2">
                  <Skeleton class="w-4rem border-round h-2rem" />
                  <Skeleton shape="circle" class="w-3rem h-3rem" />
                </div>
              </div>
            </div>
          </div>
        </template>

        <template #grid>
          <div class="col-12 sm:col-6 lg:col-12 xl:col-4 p-2">
            <div class="p-4 border-1 surface-border surface-card border-round">
              <div class="flex flex-wrap align-items-center justify-content-between gap-2">
                <Skeleton class="w-6rem border-round h-2rem" />
                <Skeleton class="w-3rem border-round h-1rem" />
              </div>
              <div class="flex flex-column align-items-center gap-3 py-5">
                <Skeleton class="w-9 shadow-2 border-round h-10rem" />
                <Skeleton class="w-8rem border-round h-2rem" />
                <Skeleton class="w-6rem border-round h-1rem" />
              </div>
              <div class="flex align-items-center justify-content-between">
                <Skeleton class="w-4rem border-round h-2rem" />
                <Skeleton shape="circle" class="w-3rem h-3rem" />
              </div>
            </div>
          </div>
        </template>
      </DataView>

      <DataView :value="Modules" :layout="Layout" v-if="!Loading"  paginator :rows="6">
        <template #header>

          <div class="grid">
            <div class="col-6 sm:col-12 flex justify-content-start border-bottom-1 surface-border">
              <span class="text-xl font-medium text-900">Course Contents</span>
            </div>
            <div class="col-6 sm:col-12 flex justify-content-end">
              <DataViewLayoutOptions v-model="Layout" />
            </div>
          </div>
        </template>

        <template #list="slotProps">
          <div class="col-12">
            <div class="flex flex-column xl:flex-row xl:align-items-start p-4 gap-4">
              <div class="flex flex-column sm:flex-row justify-content-between align-items-center xl:align-items-start flex-1 gap-4">
                <div class="flex flex-column align-items-center sm:align-items-start gap-3">
                  <Tag rounded class="bg-bluegray-800">Chapter {{ slotProps.data.moduleOrder }}</Tag>
                  <div class="flex align-items-center gap-3">
                    <span class="flex align-items-center gap-2">
                      <i class="fa fa-diamond"></i>
                      <span class="font-bold">{{ slotProps.data.moduleName }}</span>
                    </span>
                  </div>
                  <Divider class="m-0 p-0" />
                  <div class="flex align-items-center gap-3">
                    <span class="flex align-items-center gap-2">
                      <i class="pi pi-microphone" style="font-size: 1.5rem"></i>
                      <span class="font-medium font-italic">{{ slotProps.data.moduleSubHeading }}</span>
                    </span>
                  </div>
                </div>
                <div class="flex sm:flex-column align-items-center sm:align-items-end gap-3 sm:gap-2">
                  <Button icon="pi pi-arrow-circle-right" label="Go" iconPos="right" severity="secondary" type="text" placeholder="Right" class="bg-bluegray-600 border-bluegray-600" @click="GoToChapterContent(`${slotProps.data.moduleId}`, `${slotProps.data.moduleName}`, `${slotProps.data.moduleOrder}`)"></Button>
                </div>
              </div>
            </div>
          </div>
        </template>

        <template #grid="slotProps">
          <div class="col-12 sm:col-6 lg:col-12 xl:col-4 p-2 ">
            <div class="p-2 border-2 surface-border surface-card border-round shadow-1" style="height:100%">
              <div class="flex flex-wrap align-items-center justify-content-between gap-2">
                <div class="flex align-items-center gap-2">
                  <Tag rounded class="bg-bluegray-800">Chapter {{ slotProps.data.moduleOrder }}</Tag>
                </div>
           
              </div>
              <div class="flex flex-column align-items-center gap-3 py-5">
                <i class="fa fa-diamond fa-2x"></i>
                <div class="text-2xl font-bold">{{ slotProps.data.moduleName }}</div>
                <Divider class="m-0 p-0" />
                <div class="flex align-items-center gap-3">
                  <span class="flex align-items-center gap-2 flex-grow">
                    <span class="font-medium font-italic">{{ slotProps.data.moduleSubHeading }}</span>
                  </span>
                </div>
              </div>
              <div class="flex align-items-center justify-content-end">
                <Button icon="pi pi-arrow-circle-right" label="Go" iconPos="right" severity="secondary" @click="GoToChapterContent(`${slotProps.data.moduleId}`, `${slotProps.data.moduleName}`, `${slotProps.data.moduleOrder}`)" class="bg-bluegray-600 border-bluegray-600"></Button>
              </div>
            </div>
          </div>
        </template>
      </DataView>
    </div>
  </div>

</template>

<style>
  .p-rating .p-rating-item.p-rating-item-active .p-rating-icon {
    color: #f29217;
  }

  .p-selectbutton .p-button.p-highlight:hover {
    background: #9E9E9E;
    border-color: #9E9E9E;
    color: #ffffff;
  }

  .p-selectbutton .p-button.p-highlight:hover {
    background: #FF9800;
    border-color: #FF9800;
    color: #ffffff;
  }

  .p-selectbutton .p-button.p-highlight {
    background: #FF5722;
    border-color: #FF5722;
    color: #ffffff;
  }

  .p-button:focus {
    box-shadow: 0 0 0 2px #ffffff, 0 0 0 4px #FF9800, 0 1px 2px 0 black;
  }
</style>

<script>
  import { ref } from "vue";

  export default {
  name: 'OnlineModules',
    data: () => ({
      Modules: [],
      Loading: true,
      CourseName: null,
      CourseId: null,
     home: {
    icon: 'pi pi-home',
    to: '/MyDashboard',
     },
      items:[
        { label: 'My Modules', to:'/ELearning' },
        { label: 'Module'},
      ],
      Layout: ref('grid')
    }),
    created() {
      this.CourseName = this.$route.query.CourseName;
      this.CourseId = this.$route.query.CourseId;
      this.items[1].label = this.$route.query.CourseName
      this.$emit("set-nav", this.$route)

      var self = this;

      self.$http.get(`/ELearning/ProductsModules?productId=${this.$route.query.CourseId}`, {}).then(function (response) {
        self.Modules = response.data
        self.Loading = false;
      })
    }, methods: {
    GoToChapterContent(moduleId, moduleName, moduleOrder) {
        this.$router.push({ path: `/ChapterContent`, query: { ModuleId: moduleId, ModuleName: `Chapter ${moduleOrder} - ${moduleName}`, CourseName: this.CourseName, CourseId: this.CourseId}})
      }
    }
}</script>